import React, { useState, useEffect } from 'react';

const VideoPreview = ({ src, file, altText, onLoadedData }) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [showPlayer, setShowPlayer] = useState(false);

  const videoSrc = file ? URL.createObjectURL(file) : src;

  useEffect(() => {
    const generateThumbnail = (videoUrl) => {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = videoUrl;
        video.crossOrigin = 'anonymous';
        video.muted = true;
        video.currentTime = 1;

        video.addEventListener('loadeddata', () => {
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL('image/jpeg'));
        });

        video.onerror = () => reject('Erreur de chargement vidéo');
      });
    };

    generateThumbnail(videoSrc).then(setThumbnail).catch(console.error);

    return () => {
      if (file) {
        URL.revokeObjectURL(videoSrc);
      }
    };
  }, [videoSrc]);

  if (showPlayer) {
    return (
      <video controls autoPlay style={{ width: '100%', maxHeight: '500px', borderRadius: '8px' }}
onLoadedData={onLoadedData} >
        <source src={videoSrc} type="video/mp4" />
        {altText}
      </video>
    );
  }

  return (
    <div
      onClick={() => setShowPlayer(true)}
      style={{
        width: '100%',
        paddingTop: '56.25%',
        position: 'relative',
        backgroundImage: `url(${thumbnail})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '8px',
        cursor: 'pointer',
      }}
    >
 
      <div style={{
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'rgba(0,0,0,0.6)',
  borderRadius: '50%',
  width: '60px',
  height: '60px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}}>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="white"
  >
    <path d="M8 5v14l11-7z"/>
  </svg>
</div>


    </div>
  );
};

export default VideoPreview;
